import { jsx as _jsx } from "react/jsx-runtime";
import ShareTab from '../ShareTabs/ShareTab';
export default function CollaboratorsTabs({ activeTab, onClick, tabNames }) {
    return tabNames.map((name) => {
        return (_jsx(ShareTab, { isActive: activeTab === name, name: name, onClick: () => onClick(name), children: name }, name));
    });
}
